import { Metamodel } from '../base/model';
import { IModel, IAttribute, ModelConstants } from 'shell-models-lib';
import { Activity } from './activity';

import { format } from 'app/shared/utils/string.util';

@Metamodel.model({
    name: ModelConstants.waitActivity,
    display: [
        format(stringResources.ModelName_ActivityTemplate, stringResources.WaitActivityLabel),
        format(stringResources.ModelName_ActivitiesTemplate, stringResources.WaitActivityLabel)
    ],
    referable: true
})
export class WaitActivity extends Activity {
    public static readonly MODEL: IModel;
    public static readonly WAIT_TIME: IAttribute;

    @Metamodel.attribute({
        display: stringResources.WaitActivity_WaitTime,
        association: 'WAIT_TIME',
        templatable: true,
        accepts: ['Int'],
        constraint: {
            required: true,
            whole: true,
            minimum: 1
        }
    })
    public waitTimeInSeconds: number = 1;

    constructor(name?: string, description?: string) {
        super(name, description);
        this.activityType = 'ControlActivity';
    }
}
